(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cabgear-home-news"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initNews = (section) => {
    if (!section || section.dataset.cgNewsReady === 'true') return;

    const grid = section.querySelector('.cg-home-news__grid');
    const controls = section.querySelector('.cg-home-news__controls');
    const prev = section.querySelector('[data-cg-news-prev]');
    const next = section.querySelector('[data-cg-news-next]');

    if (!grid || !controls || !prev || !next) return;

    section.dataset.cgNewsReady = 'true';

    const updateControls = () => {
      const maxScroll = Math.max(0, grid.scrollWidth - grid.clientWidth);
      const hasOverflow = maxScroll > 2;

      controls.hidden = !hasOverflow;
      prev.disabled = !hasOverflow || grid.scrollLeft <= 2;
      next.disabled = !hasOverflow || grid.scrollLeft >= maxScroll - 2;
    };

    const scrollCards = (direction) => {
      const card = grid.querySelector('.cg-home-news-card');
      if (!card) return;

      const gap = parseFloat(getComputedStyle(grid).gap) || 0;
      grid.scrollBy({
        left: direction * (card.getBoundingClientRect().width + gap),
        behavior: 'smooth'
      });
    };

    prev.addEventListener('click', () => scrollCards(-1));
    next.addEventListener('click', () => scrollCards(1));
    grid.addEventListener('scroll', updateControls, { passive: true });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(updateControls);
      observer.observe(grid);
    }

    updateControls();
  };

  document.querySelectorAll('.cg-home-news').forEach(initNews);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector?.('.cg-home-news');
    if (section) initNews(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cabgear_model_page"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initMachineDialog = (root) => {
    if (!root || root.dataset.cgMachineDialogReady === 'true') return;

    const openButton = root.querySelector('[data-cg-machine-open]');
    const dialog = root.querySelector('[data-cg-machine-dialog]');

    if (!openButton || !dialog) return;

    root.dataset.cgMachineDialogReady = 'true';

    const closeButton = dialog.querySelector('[data-cg-machine-close]');
    const confirmButton = dialog.querySelector('[data-cg-machine-confirm]');

    const openDialog = () => {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    };

    const closeDialog = () => {
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
        openButton.focus({ preventScroll: true });
      }
    };

    openButton.addEventListener('click', openDialog);

    if (closeButton) closeButton.addEventListener('click', closeDialog);
    if (confirmButton) confirmButton.addEventListener('click', closeDialog);

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });

    dialog.addEventListener('close', () => {
      openButton.focus({ preventScroll: true });
    });
  };

  document.querySelectorAll('[data-cg-model-page]').forEach(initMachineDialog);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-cg-model-page]').forEach(initMachineDialog);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
